import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import {
	ANALYTICS_SOURCE,
	BulkSpacePermissionsPage,
} from '@confluence/bulk-permissions/entry-points/BulkPermissions.tsx';
import { BulkAccessManagementPage } from '@confluence/bulk-permissions/entry-points/BulkAccess.tsx';
import { expVal } from '@confluence/feature-experiments';
import { AdminPageLayout } from '@confluence/site-permissions/entry-points/AdminPageLayout.ts';
import { useSpaceRoleMode } from '@confluence/space-utils/entry-points/useSpaceRoleMode.ts';

export const BulkSpacePermissionsRoute = () => {
	const { isRbacEnabled } = useSpaceRoleMode();

	if (!isRbacEnabled) {
		return <BulkSpacePermissionsPage />;
	}

	if (expVal('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false)) {
		return (
			<AdminPageLayout>
				<BulkAccessManagementPage />
			</AdminPageLayout>
		);
	}

	return <BulkAccessManagementPage />;
};

BulkSpacePermissionsRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
